import { useEffect, useRef } from "react";

export const TrustpilotWidget = () => {
    const ref = useRef(null);
    useEffect(() => {
        if (window.Trustpilot) {
            window.Trustpilot.loadFromElement(ref.current, true);
        }
    }, []);

    return (
        <div
            ref={ref}
            className="trustpilot-widget"
            data-locale="en-GB"
            data-template-id="53aa8807dec7e10d38f59f32"
            data-businessunit-id="624b698e8a92c7df7ab8c9a9"
            data-style-height="82px"
            data-style-width="100%">

            <a
                href="https://uk.trustpilot.com/review/skillstg.co.uk"
                target="_blank"
                rel="noopener">Trustpilot</a>
        </div>
    );
};
